import { render } from "./LinkEntityToPeopleDialog.vue?vue&type=template&id=30493c27"
import script from "./LinkEntityToPeopleDialog.vue?vue&type=script&lang=js"
export * from "./LinkEntityToPeopleDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__